export default __webpack_public_path__ + "static/media/primeicons.ea535860.ttf";